import { Keyed } from "./Form";

export interface support_check_response{
    id:number;
    section_id:number;
    label:string;
    order:number;

    key?:string;
}
export class SupportCheck extends Keyed{
    public id:number = 0;
    public sectionId:number = 0;
    public label:string = '';
    public order:number = 0;

    public map(data:support_check_response){
        this.id = data.id;
        this.sectionId = data.section_id;
        this.label = data.label;
        this.order = data.order;

        return this;
    }
    public responsify():support_check_response{
        return {
            id: this.id,
            section_id: this.sectionId,
            label: this.label,
            order: this.order,

            key:this.key,
        }
    }
    public static create(data:support_check_response){
        let r = new this;
        r.map(data);
        return r;
    }
}